import { Helpers } from '@app/shared/helpers';
import {
	BaseModelSearchParams,
	BaseModelSearchParamsInterface,
} from '@app/abstracts';
import { SignatureRemovalRequestStatus } from './signature-removal-request';

/** Used to export and import search params */
export interface SignatureRemovalRequestSearchParamsInterface
	extends BaseModelSearchParamsInterface {
	_sort?: '_id' | 'created_at' | 'attestation_date' | 'status';
	_id?: string[];
	attestation?: string;
	thematique?: string;
	formation?: string;
	stagiaire?: string;
	requester?: string;
	status?: SignatureRemovalRequestStatus;
	created_at__min?: string | number | Date;
	created_at__max?: string | number | Date;
}

/** Manage signature removal request search params */
export class SignatureRemovalRequestSearchParams extends BaseModelSearchParams<SignatureRemovalRequestSearchParamsInterface> {
	/** @inheritDoc */
	fromObject(
		input: Partial<SignatureRemovalRequestSearchParamsInterface>
	): void {
		// Clone object with allowed keys only
		const props = {} as SignatureRemovalRequestSearchParamsInterface;
		this.allowedKeys().map((key: string) => {
			if (typeof input[key] !== 'undefined') {
				props[key] = input[key];
			}
		});

		// Keep default values
		if (typeof props._page === 'undefined') {
			props._page = this.defaultPage;
		}
		if (typeof props._limit === 'undefined') {
			props._limit = this.defaultLimit;
		}
		if (typeof props._sort === 'undefined') {
			props._sort = this.defaultSort;
		}
		if (typeof props._order === 'undefined') {
			props._order = this.defaultOrder;
		}
		// Convert potentially multiple primary keys
		if (typeof props._id === 'string') {
			props._id = (<string>props._id).split(',').filter((s) => s.length);
		}

		// Convert dates for created_at boundaries
		if (typeof props.created_at__min !== 'undefined') {
			props.created_at__min = Helpers.convertToDate(
				props.created_at__min
			);
		}
		if (typeof props.created_at__max !== 'undefined') {
			props.created_at__max = Helpers.convertToDate(
				props.created_at__max
			);
		}

		// Assign values
		this.props = props;
		this.next();
	}

	/** @inheritDoc */
	toObject(): SignatureRemovalRequestSearchParamsInterface {
		// Filter not allowed, undefined and null values
		const props = {} as SignatureRemovalRequestSearchParamsInterface;
		this.allowedKeys().map(Helpers.prepareObjectForApi(this.props, props));
		return props;
	}

	/** @inheritDoc */
	protected allowedKeys(): string[] {
		return super
			.allowedKeys()
			.concat([
				'_id',
				'attestation',
				'thematique',
				'formation',
				'stagiaire',
				'requester',
				'status',
				'created_at__min',
				'created_at__max',
			]);
	}
}
